/* ============================================================================
   LAH — APLICAR A COMBINACAO MULTIFOCAL SALVA
   Tema: Setembro/Outubro (Layout 3.0)

   Le a combinacao que o cliente montou na pagina /pages/multifocal e oferece
   aplica-la de uma vez na pagina do oculos.

   ============================================================================
   POR QUE UM CONVITE, E NAO APLICAR SOZINHO
   ============================================================================
   Poderiamos marcar as opcoes assim que o configurador abrisse. Mas o cliente
   pode ter voltado para comprar OUTRA coisa — um oculos de sol, uma armacao
   para a filha — e encontrar o fluxo preenchido com lentes que ele nao pediu
   agora seria estranho.

   O convite acima do botao de compra deixa a decisao com ele: um toque aplica,
   e o "descartar" apaga a combinacao para nao insistir.

   ============================================================================
   COMO APLICA
   ============================================================================
   Clicando nas proprias opcoes do configurador, uma etapa por vez, esperando
   a seguinte aparecer. E o mesmo metodo do quiz interno e da retomada: o
   Alpine calcula preco, avanca etapa e monta o resumo por conta propria — nao
   duplicamos logica nenhuma.

   Tentativas limitadas em cada etapa: se o catalogo mudou e uma opcao nao
   existe mais, paramos em silencio e o cliente segue escolhendo com a mao.
   Nunca travamos o fluxo de compra.

   ESPESSURA INDEFINIDA: quem nao sabia o grau no quiz nao tem espessura
   salva. Aplicamos tipo e campo de visao e paramos na etapa de espessura —
   o cliente escolhe ali, com a receita em maos.

   ============================================================================
   VALIDADE DE 30 DIAS
   ============================================================================
   Mais que a retomada (7 dias), porque quem compra multifocal pesquisa mais e
   decide devagar. Passado isso, o preco ou o catalogo podem ter mudado.
   ============================================================================ */

(function () {
    'use strict';

    var CHAVE = 'lah_mf_config';
    var VALIDADE_MS = 30 * 24 * 60 * 60 * 1000;

    var ETAPA_TIPO = 'tipo-de-lente';
    var ETAPA_CAMPO = 'campo-de-visao';
    var ETAPA_ESPESSURA = 'espessura-de-suas-lentes-multifocais';
    var ETAPA_TRATAMENTO = 'tratamento';

    var raiz = document.querySelector('.product-lens-select');
    var cta = document.querySelector('.openProductLens');
    if (!raiz || !cta) return;

    function ler() {
        try {
            var c = JSON.parse(window.localStorage.getItem(CHAVE) || 'null');
            if (!c || !c.campo) return null;
            if (Date.now() - (c.em || 0) > VALIDADE_MS) {
                window.localStorage.removeItem(CHAVE);
                return null;
            }
            return c;
        } catch (e) {
            return null;
        }
    }

    function apagar() {
        try { window.localStorage.removeItem(CHAVE); } catch (e) {}
    }

    function track(ev, dados) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: ev }, dados || {}));
        } catch (e) {}
    }

    function normalize(t) {
        return (t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    }

    function acharEtapa(fragmento) {
        var etapas = raiz.querySelectorAll('.product-lens-select-step');
        for (var i = 0; i < etapas.length; i++) {
            if ((etapas[i].getAttribute('data-step-selector') || '').indexOf(fragmento) !== -1) {
                return etapas[i];
            }
        }
        return null;
    }

    /* Busca pelo nome, ignorando acento e caixa. Na etapa de tipo aceita
       correspondencia parcial: o nome la e "Multifocal" mas pode vir com
       complemento no metaobjeto. */
    function acharOpcao(etapa, nome, parcial) {
        if (!etapa) return null;
        var alvo = normalize(nome);
        var itens = etapa.querySelectorAll('.product-lens-select-item');

        for (var i = 0; i < itens.length; i++) {
            var n = normalize(itens[i].getAttribute('data-item-name'));
            if (n === alvo || (parcial && n.indexOf(alvo) !== -1)) return itens[i];
        }
        return null;
    }

    /* So faz sentido em produto cujo configurador oferece multifocal — em
       oculos de sol, por exemplo, o convite nao aparece. */
    if (!acharOpcao(acharEtapa(ETAPA_TIPO), 'multifocal', true)) return;

    var config = ler();
    if (!config) return;

    /* ---------------------------------------------------------------------
       APLICAR — uma etapa por vez
       --------------------------------------------------------------------- */
    function clicarQuando(etapaFrag, nome, parcial, depois) {
        var tentativas = 0;

        (function tentar() {
            var etapa = acharEtapa(etapaFrag);
            var opcao = acharOpcao(etapa, nome, parcial);
            var visivel = etapa && etapa.offsetParent !== null;

            if (opcao && visivel) {
                opcao.click();
                requestAnimationFrame(function () {
                    setTimeout(function () { if (depois) depois(); }, 120);
                });
                return;
            }

            tentativas++;
            if (tentativas > 40) return; /* catalogo mudou: paramos em silencio */
            setTimeout(tentar, 80);
        })();
    }

    function aplicar() {
        track('mf_config_aplicada', {
            campo: config.campo,
            espessura: config.espessura || 'indefinida',
            tratamento: config.tratamento
        });

        cta.click();

        setTimeout(function () {
            clicarQuando(ETAPA_TIPO, 'multifocal', true, function () {
                clicarQuando(ETAPA_CAMPO, config.campo, false, function () {
                    /* Sem espessura salva: paramos aqui, na etapa de
                       espessura — ver a nota no topo. */
                    if (!config.espessura) return;

                    clicarQuando(ETAPA_ESPESSURA, config.espessura, false, function () {
                        clicarQuando(ETAPA_TRATAMENTO, config.tratamento, false, null);
                    });
                });
            });
        }, 300);
    }

    /* ---------------------------------------------------------------------
       O CONVITE
       --------------------------------------------------------------------- */
    var estilo = document.createElement('style');
    estilo.textContent =
        '.lah-mfa{border:1px solid rgba(33,65,50,.2);background:#F4F8F5;border-radius:12px;' +
        'padding:14px 16px;margin:0 0 12px;}' +
        '.lah-mfa__t{margin:0;font-weight:500;}' +
        '.lah-mfa__d{margin:4px 0 12px;opacity:.75;}' +
        '.lah-mfa__acoes{display:flex;gap:12px;align-items:center;flex-wrap:wrap;}' +
        '.lah-mfa__x{background:none;border:0;padding:0;font:inherit;color:inherit;' +
        'opacity:.6;text-decoration:underline;cursor:pointer;}';
    document.head.appendChild(estilo);

    var partes = [config.campo];
    if (config.espessura) partes.push(config.espessura.replace(/^Multifocal\s+/i, ''));
    partes.push(config.tratamento);

    var caixa = document.createElement('div');
    caixa.className = 'lah-mfa';
    caixa.innerHTML =
        '<p class="lah-mfa__t">Sua combinação multifocal está pronta</p>' +
        '<p class="lah-mfa__d text--small">' + partes.join(' · ') + '</p>' +
        '<div class="lah-mfa__acoes">' +
        '<button type="button" class="button button--primary" data-mfa-aplicar>Aplicar nestes óculos</button>' +
        '<button type="button" class="lah-mfa__x text--small" data-mfa-descartar>Descartar</button>' +
        '</div>';

    cta.parentNode.insertBefore(caixa, cta);
    track('mf_config_convite', { campo: config.campo });

    caixa.addEventListener('click', function (event) {
        if (event.target.closest('[data-mfa-aplicar]')) {
            aplicar();
            return;
        }

        if (event.target.closest('[data-mfa-descartar]')) {
            track('mf_config_descartada', {});
            apagar();
            caixa.remove();
        }
    });
})();
